import React from 'react';
import TravelExpenses from './TravelExpenses';

const TravelExpensesPage = () => {
    return (
        <div className="p-6 bg-gray-50 dark:bg-gray-900 min-h-screen">
            <TravelExpenses />
        </div>
    );
};

export default TravelExpensesPage;
